import { render, staticRenderFns } from "./calculator.vue?vue&type=template&id=2a195c14&scoped=true&"
import script from "./calculator.vue?vue&type=script&lang=js&"
export * from "./calculator.vue?vue&type=script&lang=js&"
import style0 from "./calculator.vue?vue&type=style&index=0&id=2a195c14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a195c14",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Calculator: require('/app/components/Calculator.vue').default})
